<template>
  <div>
    <div id="headerCommon"></div>
  </div>
</template>
<script>
  export default {
    name: 'd-header'
  }
</script>



/** WEBPACK FOOTER **
 ** DHeader.vue?33e7bd97
 **/